import { useEffect } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';

const Beaumont = () => {
  useEffect(() => {
    // Update page meta tags
    document.title = 'We Buy Valves Beaumont | Industrial Equipment Buyers Beaumont Texas';
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'We buy valves Beaumont Texas - Professional valve buyers in Beaumont. We buy surplus valves, Fisher control valves, instrumentation from ExxonMobil, Chevron Phillips. Same-day response 214-854-5638.');
    }
    
    // Update meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'valve buyers beaumont, texas industrial equipment, surplus valves beaumont, fisher control valves texas, refinery equipment buyers');
    }
    
    // Update canonical URL
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', 'https://valvesalessupply.com/beaumont');
    }
    
    // Update Open Graph tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'Beaumont Texas Valve Buyers - Industrial Equipment Buyers | ValveSalesSupply');
    }
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'Professional valve buyers Beaumont Texas - We buy surplus valves, Fisher control valves, instrumentation from ExxonMobil, Chevron Phillips. Same-day response 214-854-5638.');
    }
    
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', 'https://valvesalessupply.com/beaumont');
    }

    // Add geo meta tags for Beaumont
    const geoPosition = document.createElement('meta');
    geoPosition.setAttribute('name', 'geo.position');
    geoPosition.setAttribute('content', '30.0800;-94.1266');
    document.head.appendChild(geoPosition);

    const geoRegion = document.createElement('meta');
    geoRegion.setAttribute('name', 'geo.region');
    geoRegion.setAttribute('content', 'US-TX');
    document.head.appendChild(geoRegion);

    const geoPlacename = document.createElement('meta');
    geoPlacename.setAttribute('name', 'geo.placename');
    geoPlacename.setAttribute('content', 'Beaumont, Texas');
    document.head.appendChild(geoPlacename);

    // Add Schema.org structured data
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://valvesalessupply.com/beaumont/#webpage",
          "url": "https://valvesalessupply.com/beaumont",
          "name": "Beaumont Texas Valve Buyers - Industrial Equipment Buyers | ValveSalesSupply",
          "description": "Professional valve buyers Beaumont Texas - We buy surplus valves, Fisher control valves, instrumentation from ExxonMobil, Chevron Phillips. Same-day response 214-854-5638.",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://valvesalessupply.com"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Service Areas",
                "item": "https://valvesalessupply.com/service-areas"
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": "Texas",
                "item": "https://valvesalessupply.com/texas"
              },
              {
                "@type": "ListItem",
                "position": 4,
                "name": "Beaumont",
                "item": "https://valvesalessupply.com/beaumont"
              }
            ]
          }
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What types of valves do you buy in Beaumont Texas?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We buy all types of industrial valves from Beaumont area refineries including Fisher control valves, gate valves, globe valves, ball valves, check valves, butterfly valves, and safety relief valves. We purchase from ExxonMobil Beaumont, Chevron Phillips Cedar Bayou, and other Golden Triangle refineries."
              }
            }
          ]
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      // Cleanup meta tags and schema
      document.head.removeChild(geoPosition);
      document.head.removeChild(geoRegion);
      document.head.removeChild(geoPlacename);
      document.head.removeChild(script);
    };
  }, []);

  const beaumontFacilities = [
    { name: 'ExxonMobil Beaumont', location: 'Beaumont', capacity: '365,000 bpd' },
    { name: 'Chevron Phillips Cedar Bayou', location: 'Baytown', capacity: '247,000 bpd' },
    { name: 'Motiva Port Arthur', location: 'Port Arthur', capacity: '635,000 bpd' },
    { name: 'Total Port Arthur', location: 'Port Arthur', capacity: '225,000 bpd' },
    { name: 'LyondellBasell Houston', location: 'Houston', capacity: '270,000 bpd' }
  ];

  const faqData = [
    {
      question: "What types of valves do you buy in Beaumont Texas?",
      answer: "We buy all types of industrial valves from Beaumont area refineries including Fisher control valves, gate valves, globe valves, ball valves, check valves, butterfly valves, and safety relief valves. We purchase from ExxonMobil Beaumont, Chevron Phillips Cedar Bayou, and other Golden Triangle refineries."
    },
    {
      question: "How quickly can you respond to Golden Triangle refineries?",
      answer: "We provide same-day response to all Beaumont, Port Arthur, and Orange area facilities. Our Texas team can typically be on-site within 2-4 hours for equipment assessments from our Houston operations center. We maintain inventory facilities near the Golden Triangle."
    },
    {
      question: "Do you buy instrumentation from Texas Gulf Coast facilities?",
      answer: "Yes! We purchase all types of process instrumentation from Beaumont area refineries including Rosemount transmitters, flow meters, pressure gauges, temperature instruments, analyzers, and control systems. We buy from Honeywell, Emerson, Foxboro, Yokogawa, and other leading manufacturers."
    },
    {
      question: "What documentation do you provide for equipment purchases?",
      answer: "We provide complete regulatory compliance documentation for all equipment purchased from Texas refineries. This includes proper disposal certificates, material transfer records, and all required environmental paperwork to ensure your facility remains compliant with TCEQ and federal regulations."
    },
    {
      question: "Do you coordinate with planned turnarounds in the Golden Triangle?",
      answer: "Absolutely! We specialize in coordinating equipment removal during planned turnarounds at Beaumont, Port Arthur, and surrounding refineries. Our team works within your maintenance schedule to efficiently remove surplus equipment while maximizing your return on investment."
    },
    {
      question: "How do you price equipment from Texas Gulf Coast refineries?",
      answer: "Our pricing is based on current market conditions, equipment condition, manufacturer, model, size, and demand. We pay significantly above scrap prices for functional equipment. Our Texas team has extensive knowledge of Gulf Coast refinery equipment values and provides competitive pricing."
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/400f9ed1dafbee31585bf2cf91bcb6a4.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#1B3A5F]/90 to-[#1B3A5F]/70"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-white">
          <div className="max-w-4xl">
            <h1 className="text-5xl font-bold mb-6">We Buy Valves Beaumont Texas</h1>
            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              Leading <strong>valve buyers Beaumont</strong> Golden Triangle - We purchase surplus valves, control valves, 
              instrumentation, and refinery equipment from ExxonMobil, Chevron Phillips, and Motiva refineries. 
              Same-day response and competitive pricing for all Texas Gulf Coast facilities.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:214-854-5638"
                className="bg-white text-[#1B3A5F] px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                CALL 214-854-5638
              </a>
              <Link
                to="/contact"
                className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-[#1B3A5F] transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                GET BEAUMONT QUOTE
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Beaumont Market Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-[#1B3A5F] text-4xl font-bold mb-6">BEAUMONT VALVE BUYERS - GOLDEN TRIANGLE EXPERTS</h2>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                The Golden Triangle is home to America's largest refining complex. As experienced 
                <strong className="text-[#1B3A5F]"> Beaumont valve buyers</strong> and 
                <strong className="text-[#1B3A5F]"> Port Arthur equipment buyers</strong>, we specialize in 
                purchasing surplus equipment from this critical refining hub.
              </p>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                We buy <strong className="text-[#1B3A5F]">Fisher control valves Beaumont</strong>, 
                surplus gate valves, Rosemount transmitters, and safety relief valves from 
                ExxonMobil, Total, Valero, and all Golden Triangle facilities.
              </p>
              
              <div className="grid md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">1.2M+</div>
                  <div className="text-gray-600">BPD Capacity</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">2-3 Hrs</div>
                  <div className="text-gray-600">Response Time</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">15+</div>
                  <div className="text-gray-600">Major Facilities</div>
                </div>
              </div>
            </div>
            
            <div className="bg-[#F5F7FA] rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">GOLDEN TRIANGLE FACILITIES</h3>
              <div className="space-y-4">
                {beaumontFacilities.map((facility, index) => (
                  <div key={index} className="flex justify-between items-center bg-white rounded-lg p-4">
                    <div>
                      <h4 className="text-[#1B3A5F] font-bold text-lg">{facility.name}</h4>
                      <p className="text-gray-600 text-sm">{facility.location}</p>
                    </div>
                    <div className="text-right">
                      <div className="text-[#1B3A5F] font-semibold">{facility.capacity || facility.type}</div>
                      <div className="text-gray-600 text-sm">{facility.capacity ? 'Capacity' : 'Type'}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Equipment We Buy */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">SELL VALVES BEAUMONT - WE PAY TOP DOLLAR</h2>
            <p className="text-gray-600 text-xl">Professional equipment buyers serving the Golden Triangle</p>
          </div>
          
          <div className="grid lg:grid-cols-3 gap-8">
            {[
              {
                category: 'Refinery Valves Beaumont',
                brands: ['Fisher', 'Masoneilan', 'Flowserve', 'Cameron'],
                types: ['Control Valves', 'Gate Valves', 'Globe Valves', 'Check Valves']
              },
              {
                category: 'Petrochemical Equipment',
                brands: ['Rosemount', 'Emerson', 'Honeywell', 'ABB'],
                types: ['Transmitters', 'Controllers', 'Analyzers', 'Flow Meters']
              },
              {
                category: 'Safety Systems Beaumont',
                brands: ['Anderson Greenwood', 'Crosby', 'Consolidated', 'Farris'],
                types: ['Relief Valves', 'Safety Valves', 'Rupture Discs', 'Flame Arrestors']
              }
            ].map((equipment, index) => (
              <div key={index} className="bg-white rounded-3xl p-8 hover:shadow-lg transition-all duration-300">
                <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">{equipment.category}</h3>
                
                <div className="mb-6">
                  <h4 className="text-gray-800 font-bold mb-3">Top Brands We Buy:</h4>
                  <div className="grid grid-cols-2 gap-2">
                    {equipment.brands.map((brand, brandIndex) => (
                      <div key={brandIndex} className="bg-[#1B3A5F]/10 text-[#1B3A5F] px-3 py-2 rounded-lg text-sm font-medium text-center">
                        {brand}
                      </div>
                    ))}
                  </div>
                </div>
                
                <div>
                  <h4 className="text-gray-800 font-bold mb-3">Equipment Types:</h4>
                  <div className="space-y-2">
                    {equipment.types.map((type, typeIndex) => (
                      <div key={typeIndex} className="flex items-center">
                        <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                        <span className="text-gray-600">{type}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* We Buy Surplus Valves Beaumont */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">WE BUY SURPLUS VALVES BEAUMONT</h2>
            <p className="text-gray-600 text-xl">Beaumont's premier surplus valve buyers - serving the Golden Triangle</p>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h3 className="text-[#1B3A5F] text-3xl font-bold mb-6">BEAUMONT SURPLUS VALVE SPECIALISTS</h3>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                As <strong className="text-[#1B3A5F]">Beaumont's leading surplus valve buyers</strong>, 
                we specialize in purchasing high-quality used valves from the Golden Triangle's massive 
                refining complex. Our proximity to ExxonMobil Beaumont, Total Port Arthur, and Motiva 
                ensures rapid response times and maximum value for your surplus valve inventory.
              </p>
              
              <div className="space-y-4 mb-8">
                {[
                  {
                    type: 'Golden Triangle Refinery Valves',
                    description: 'Fisher, Masoneilan from ExxonMobil, Total, Motiva facilities',
                    count: '800+ Units',
                    icon: 'ri-oil-line'
                  },
                  {
                    type: 'Petrochemical Grade Valves',
                    description: 'Specialty valves from Beaumont petrochemical operations',
                    count: '400+ Units',
                    icon: 'ri-flask-line'
                  },
                  {
                    type: 'Port Arthur Complex Valves',
                    description: 'Gate and globe valves from world\'s largest refining center',
                    count: '600+ Units',
                    icon: 'ri-building-4-line'
                  },
                  {
                    type: 'Safety Relief Systems',
                    description: 'Anderson Greenwood, Crosby from Golden Triangle plants',
                    count: '250+ Units',
                    icon: 'ri-shield-check-line'
                  }
                ].map((valve, index) => (
                  <div key={index} className="bg-[#F5F7FA] rounded-lg p-4">
                    <div className="flex items-start">
                      <div className="w-12 h-12 bg-[#1B3A5F] rounded-lg flex items-center justify-center mr-4">
                        <i className={`${valve.icon} text-white text-xl`}></i>
                      </div>
                      <div className="flex-1">
                        <div className="flex justify-between items-start mb-2">
                          <h4 className="text-[#1B3A5F] font-bold text-lg">{valve.type}</h4>
                          <span className="text-[#1B3A5F] text-sm font-semibold">{valve.count}</span>
                        </div>
                        <p className="text-gray-600 text-sm">{valve.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="bg-gradient-to-r from-[#1B3A5F] to-[#2B5F8F] rounded-lg p-6 text-white">
                <h4 className="font-bold mb-3">Golden Triangle Advantage:</h4>
                <div className="grid md:grid-cols-2 gap-3">
                  <div className="flex items-center">
                    <i className="ri-time-line mr-3"></i>
                    <span>2-3 hour response</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-money-dollar-circle-line mr-3"></i>
                    <span>Highest Southeast TX prices</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-truck-line mr-3"></i>
                    <span>Local logistics hub</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-award-line mr-3"></i>
                    <span>Golden Triangle expertise</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div 
              className="rounded-3xl overflow-hidden shadow-lg bg-cover bg-center h-96"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Beaumont%20Golden%20Triangle%20refinery%20surplus%20valves%20Fisher%20control%20valves%20Masoneilan%20gate%20valves%20ExxonMobil%20Total%20Port%20Arthur%20professional%20industrial%20valve%20warehouse%20organized%20inventory&width=600&height=400&seq=beaumont-surplus-valves-013&orientation=landscape')`
              }}
            >
              <div className="bg-gradient-to-t from-[#1B3A5F]/80 to-transparent h-full flex items-end p-8">
                <div className="text-white">
                  <h3 className="text-2xl font-bold mb-2">Golden Triangle Certified Valves</h3>
                  <p>Premium surplus valves from America's largest refining hub</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-[#1B3A5F]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-white text-4xl font-bold mb-4">BEAUMONT VALVE BUYERS - CALL TODAY</h2>
            <p className="text-gray-200 text-xl">Fast quotes for Golden Triangle equipment</p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="bg-white rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">BEAUMONT LOCAL OFFICE</h3>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-center">
                  <i className="ri-phone-line text-[#1B3A5F] text-xl mr-4"></i>
                  <div>
                    <div className="font-bold text-lg">214-854-5638</div>
                    <div className="text-gray-600">Golden Triangle Direct Line</div>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <i className="ri-mail-line text-[#1B3A5F] text-xl mr-4"></i>
                  <div>
                    <div className="font-bold">beaumont@valvesalessupply.com</div>
                    <div className="text-gray-600">Equipment Lists & Photos</div>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <i className="ri-time-line text-[#1B3A5F] text-xl mr-4 mt-1"></i>
                  <div>
                    <div className="font-bold">2-3 Hour Response</div>
                    <div className="text-gray-600">Fastest in Golden Triangle</div>
                  </div>
                </div>
              </div>
              
              <div className="bg-[#F5F7FA] rounded-lg p-4">
                <h4 className="text-[#1B3A5F] font-bold mb-2">Southeast Texas Manager</h4>
                <p className="text-gray-600">Mark Driver - Golden Triangle specialist</p>
              </div>
            </div>
            
            <div className="text-white">
              <h3 className="text-3xl font-bold mb-6">GOLDEN TRIANGLE ADVANTAGE</h3>
              <div className="space-y-4">
                {[
                  'Highest valve prices in Southeast Texas',
                  'Fastest 2-3 hour response times',
                  'Expert Golden Triangle experience',
                  'Complete regulatory compliance',
                  'Local Beaumont team with refinery knowledge',
                  'Emergency turnaround coordination'
                ].map((benefit, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-white text-xl mr-4"></i>
                    <span className="text-lg">{benefit}</span>
                  </div>
                ))}
              </div>
              
              <div className="mt-8">
                <a
                  href="tel:214-854-5638"
                  className="bg-white text-[#1B3A5F] px-10 py-4 rounded-full text-xl font-semibold hover:bg-gray-100 transition-all duration-300 inline-flex items-center whitespace-nowrap"
                >
                  CALL: 214-854-5638
                  <i className="ri-phone-line ml-2"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Service Areas */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Our Service Coverage in Beaumont
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              We provide equipment pickup services throughout the greater Beaumont metropolitan area
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Beaumont Industrial</h3>
              <p className="text-gray-600">Port Arthur, Nederland, Groves areas</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">East Beaumont</h3>
              <p className="text-gray-600">Winnie, Stowell, Anahuac areas</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">West Beaumont</h3>
              <p className="text-gray-600">Orange, Vidor, Bridge City areas</p>
            </div>
          </div>
        </div>
      </section>

      {/* Premium Equipment Brands Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Premium Equipment Brands We Buy in Beaumont
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              We purchase top-quality petrochemical and refinery equipment from leading manufacturers in Beaumont, Texas
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-orange-50 to-red-50 p-6 rounded-lg border border-orange-100">
              <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-settings-3-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Refinery Valves Beaumont</h3>
              <p className="text-gray-600 mb-4">
                Fisher Control Valves Beaumont, Masoneilan Beaumont, Q-Check Beaumont, Valtek Beaumont
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-orange-100 text-orange-800 text-sm rounded">Fisher Beaumont</span>
                <span className="px-2 py-1 bg-orange-100 text-orange-800 text-sm rounded">Masoneilan Beaumont</span>
                <span className="px-2 py-1 bg-orange-100 text-orange-800 text-sm rounded">Q-Check Beaumont</span>
              </div>
              <a href="/contact" className="text-orange-600 hover:text-orange-700 font-medium">Get Beaumont Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-6 rounded-lg border border-green-100">
              <div className="w-12 h-12 bg-green-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-dashboard-3-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Instrumentation Beaumont</h3>
              <p className="text-gray-600 mb-4">
                Rosemount Transmitters Beaumont, Foxboro Beaumont, Fisher Instruments Beaumont, Barton Beaumont
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-green-100 text-green-800 text-sm rounded">Rosemount Beaumont</span>
                <span className="px-2 py-1 bg-green-100 text-green-800 text-sm rounded">Foxboro Beaumont</span>
                <span className="px-2 py-1 bg-green-100 text-green-800 text-sm rounded">Fisher Beaumont</span>
              </div>
              <a href="/contact" className="text-green-600 hover:text-green-700 font-medium">Get Beaumont Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 p-6 rounded-lg border border-blue-100">
              <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-water-percent-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Flow Systems Beaumont</h3>
              <p className="text-gray-600 mb-4">
                Badger Meters Beaumont, Neptune Beaumont, Rockwell Beaumont, petrochemical flow equipment
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-blue-100 text-blue-800 text-sm rounded">Badger Beaumont</span>
                <span className="px-2 py-1 bg-blue-100 text-blue-800 text-sm rounded">Neptune Beaumont</span>
                <span className="px-2 py-1 bg-blue-100 text-blue-800 text-sm rounded">Rockwell Beaumont</span>
              </div>
              <a href="/contact" className="text-blue-600 hover:text-blue-700 font-medium">Get Beaumont Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-indigo-50 p-6 rounded-lg border border-purple-100">
              <div className="w-12 h-12 bg-purple-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-cpu-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Actuators Beaumont</h3>
              <p className="text-gray-600 mb-4">
                Limitorque Beaumont, Bettis Actuators Beaumont, Fisher Actuators Beaumont, Q-Check Beaumont
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-purple-100 text-purple-800 text-sm rounded">Limitorque Beaumont</span>
                <span className="px-2 py-1 bg-purple-100 text-purple-800 text-sm rounded">Bettis Beaumont</span>
                <span className="px-2 py-1 bg-purple-100 text-purple-800 text-sm rounded">Fisher Beaumont</span>
              </div>
              <a href="/contact" className="text-purple-600 hover:text-purple-700 font-medium">Get Beaumont Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-cyan-50 p-6 rounded-lg border border-teal-100">
              <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-plug-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Fittings Beaumont</h3>
              <p className="text-gray-600 mb-4">
                Swagelok Beaumont, Parker Fittings Beaumont, Anderson Greenwood Beaumont, Hoke Beaumont
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-teal-100 text-teal-800 text-sm rounded">Swagelok Beaumont</span>
                <span className="px-2 py-1 bg-teal-100 text-teal-800 text-sm rounded">Parker Beaumont</span>
                <span className="px-2 py-1 bg-teal-100 text-teal-800 text-sm rounded">Anderson Beaumont</span>
              </div>
              <a href="/contact" className="text-teal-600 hover:text-teal-700 font-medium">Get Beaumont Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-orange-50 p-6 rounded-lg border border-amber-100">
              <div className="w-12 h-12 bg-amber-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-temp-hot-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Temperature Beaumont</h3>
              <p className="text-gray-600 mb-4">
                WIKA Gauges Beaumont, All Temp Sensors Beaumont, OCI Beaumont, McDaniel Beaumont
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-amber-100 text-amber-800 text-sm rounded">WIKA Beaumont</span>
                <span className="px-2 py-1 bg-amber-100 text-amber-800 text-sm rounded">All Temp Beaumont</span>
                <span className="px-2 py-1 bg-amber-100 text-amber-800 text-sm rounded">OCI Beaumont</span>
              </div>
              <a href="/contact" className="text-amber-600 hover:text-amber-700 font-medium">Get Beaumont Quote →</a>
            </div>
          </div>

          <div className="mt-12 text-center">
            <div className="bg-gray-50 p-8 rounded-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Ready to Sell Your Equipment in Beaumont?</h3>
              <p className="text-lg text-gray-600 mb-6">
                Contact us today for a free quote on your surplus petrochemical and refinery equipment in Beaumont, Texas
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a href="tel:2148545638" className="bg-orange-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-orange-700 transition duration-300">
                  Call (214) 854-5638
                </a>
                <a href="/contact" className="bg-gray-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-700 transition duration-300">
                  Get Free Quote
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">BEAUMONT VALVE BUYERS - FREQUENTLY ASKED QUESTIONS</h2>
            <p className="text-gray-600 text-xl">Common questions about selling equipment to Golden Triangle buyers</p>
          </div>
          
          <div className="space-y-8">
            {faqData.map((faq, index) => (
              <div key={index} className="bg-[#F5F7FA] rounded-2xl p-8">
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-4">{faq.question}</h3>
                <p className="text-gray-700 text-lg leading-relaxed">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Beaumont;
